import { CreateProject, CreateProjectDto, CreateProjectResponse } from '../types/create-project'

const mapCreateProject = (dto: Partial<CreateProjectResponse>): CreateProject => ({
  id: dto?.id || 0,
  userId: dto.user_id || 0,
  name: dto.name || '',
  description: dto.description || '',
  activity: dto.activity || '',
  website: dto.website || '',
  conversions: dto.conversions || '',
  stateBefore: dto.state_before || '',
  stateAfter: dto.state_after || '',
  purpose: dto.purpose || null,
  resources: dto.resources || '',
  image: dto.image || '',
  billSize: dto.bill_size
    ? {
        id: dto.bill_size.id || 0,
        name: dto.bill_size.name || '',
      }
    : {
        id: 0,
        name: '',
      },
  companySize: dto.company_size
    ? {
        id: dto.company_size.id || 0,
        name: dto.company_size.name || '',
      }
    : {
        id: 0,
        name: '',
      },
  productType: dto.product_type
    ? {
        id: dto.product_type.id || 0,
        name: dto.product_type.name || '',
      }
    : {
        id: 0,
        name: '',
      },
  customerGoal: dto.customer_goal
    ? {
        id: dto.customer_goal.id || 0,
        name: dto.customer_goal.name || '',
      }
    : {
        id: 0,
        name: '',
      },
  customerProblem: dto.customer_problem
    ? {
        id: dto.customer_problem.id || 0,
        name: dto.customer_problem.name || '',
      }
    : {
        id: 0,
        name: '',
      },
  customerRequest: dto.customer_request
    ? {
        id: dto.customer_request.id || 0,
        name: dto.customer_request.name || '',
      }
    : {
        id: 0,
        name: '',
      },
  channels:
    dto.channels?.map((channel) => {
      return {
        id: Number(channel?.id || 0) || 0,
        name: String(channel?.name || ''),
        image: String(channel?.image || ''),
        description: String(channel?.description || ''),
        active: channel?.active || false,
      }
    }) || [],
})

const mapCreateProjectToDto = (project: Partial<CreateProject>): CreateProjectDto => {
  return {
    user_id: project.userId || 0,
    name: project.name || '',
    description: project.description || '',
    activity: project.activity || '',
    website: project.website || '',
    conversions: project.conversions || '',
    state_before: project.stateBefore || '',
    state_after: project.stateAfter || '',
    purpose: project.purpose || null,
    resources: project.resources || '',
    image: project.image || '',
    bill_size: {
      id: project.billSize?.id || 0,
      name: project.billSize?.name || '',
    },
    company_size: {
      id: project.companySize?.id || 0,
      name: project.companySize?.name || '',
    },
    product_type: {
      id: project.productType?.id || 0,
      name: project.productType?.name || '',
    },
    customer_goal: {
      id: project.customerGoal?.id || 0,
      name: project.customerGoal?.name || '',
    },
    customer_problem: {
      id: project.customerProblem?.id || 0,
      name: project.customerProblem?.name || '',
    },
    customer_request: {
      id: project.customerRequest?.id || 0,
      name: project.customerRequest?.name || '',
    },
    channels:
      project?.channels?.map((channel) => {
        return {
          id: Number(channel?.id || 0) || 0,
          name: String(channel?.name || ''),
          image: String(channel?.image || ''),
          description: String(channel?.description || ''),
          active: channel?.active || false,
        }
      }) || [],
  }
}

const mappers = { mapCreateProject, mapCreateProjectToDto }

export default mappers
